module.exports = __webpack_public_path__ + "img/yinxiangwen.ca251b55.jpg";